import { defineStore } from 'pinia'

export const useFingerprintStore = defineStore('fingerprint', {
  state: () => ({
    visitorId: null as string | null,
    loaded: false
  }),
  actions: {
    async initializeFingerprint() {
      if (this.loaded) return

      try {
        const { getVisitorId } = useFingerprintJS()
        this.visitorId = await getVisitorId()
        this.loaded = true
      } catch (error) {
        console.error('Failed to initialize fingerprint:', error)
      }
    }
  },
  getters: {
    getVisitorId: (state) => state.visitorId
  }
})
